import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'phone-number',
  template: `<form #phoneForm="ngForm">
              <div class="form-group">
                <label for="phoneNumber">{{ 'phoneNumber.phoneNumberLabel' | translate }}</label>
                <input type="tel" class="form-control" id="phoneNumber" placeholder="{{ 'phoneNumber.phoneNumberPlaceholder' | translate }}"
                       [required]="required" pattern="[0-9]{10}"
                       [ngModel]="phoneNumber" (ngModelChange)="this.phoneNumberChange.emit($event)" name="phoneNumber"
                       #phoneNumberField="ngModel">

                <div *ngIf="phoneNumberField.invalid && (phoneNumberField.dirty || phoneNumberField.touched)"
                     class="alert alert-danger">
                  <div *ngIf="phoneNumberField.errors.required">
                    {{ 'phoneNumber.phoneNumberRequiredMessage' | translate }}
                  </div>
                  <div *ngIf="phoneNumberField.errors.pattern">
                    {{ 'phoneNumber.phoneNumberValidMessage' | translate }}
                  </div>
                </div>
              </div>
            </form>`,
})
export class PhoneNumberComponent {
  @Input() required: boolean = true;
  @Input() phoneNumber: string;
  @Output() phoneNumberChange = new EventEmitter<string>();

  @ViewChild(NgForm) form;

  constructor() { }

}
